import React from 'react';
import MaterialMenuList from '@mui/material/MenuList';
import type {MenuListProps as MaterialMenuListProps} from '@mui/material/MenuList';

export type MenuListProps = MaterialMenuListProps;

export const MenuList = React.forwardRef<any, MenuListProps>(
    (
        {
            children,
            ...props
        },
        ref
    ) => {
        return (
            <MaterialMenuList
                ref={ref}
                {...props}
            >
                {children}
            </MaterialMenuList>
        );
    });

MenuList.displayName = 'MenuList';
